import React from 'react';
import fields from '@/constants/fields';
import CohortFilterDateTimePicker from './CohortFilterDateTimePicker';

const CohortFilterValuesDate = ({
  fieldType,
  filterUUID,
  saveErrors,
  values,
  disabled,
  onChange,
}) => {
  const validationError = saveErrors.find((e) => (
    e.context.filterUUID === filterUUID && e.fields.includes(fields.VALUE)));

  return (
    <CohortFilterDateTimePicker
      className="aridhia-cohort-filter-values-date w-100"
      disabled={disabled}
      fieldType={fieldType}
      index={0}
      onChange={onChange}
      validationError={validationError}
      values={values}
    />
  );
};

export default CohortFilterValuesDate;
